export default {"src":"/_next/static/media/back-to-top.eddd2949.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};